export default "__VITE_ASSET__Bwph$DwW__"